'use strict'

import moment from 'moment'

import css from './date-selection.styles.scss'
import template from './date-selection.template.pug'

class DateSelectionController {
  $onInit() {
    this.date = null
    this.minDate = moment()
    this.maxDate = moment().add(8, 'weeks')
    this._minDate = this.minDate.add(1, 'day').toDate()
    this._maxDate = this.maxDate.toDate()
  }

  select() {
    if (this.dateSelectionForm.date.$valid) {
      this.onSelect({ date: moment(this.date, 'DD.MM.YYYY').format('YYYY-MM-DD') })
    }
  }

  selectRadio() {
    if (this.dateSelectionForm.date.$valid) {
      this.onSelect({ date: moment(this.date).format('YYYY-MM-DD') })
    }
  }
}

export const umsDateSelection = {
  controller: DateSelectionController,
  template: template({ css }),
  bindings: {
    dates: '<',
    onSelect: '&',
  },
}



// WEBPACK FOOTER //
// ./app/orders/components/date-selection/date-selection.component.js